import axios from 'axios'
const URL = 'https://resources2.dev.api.unoapp.io'

export const API = {
  Folder: {
    getAllFoldersInRootDirectory (headers) {
      return axios.get(`${URL}/api/v1/folders?page=7&limit=2`, {
        headers: headers
      })
    },
    getResourcesInAFolder (folder, headers) {
      return axios.get(`${URL}/api/v1/folders/${folder}/resources`, {
        headers: headers
      })
    },
    createNewFolder (data, headers) {
      return axios.post(`${URL}/api/v1/folders`, data, {
        headers: headers
      })
    },
    getFolderById (folder, headers) {
      return axios.get(`${URL}/api/v1/folders/${folder}`, {
        headers: headers
      })
    },
    delete (folder, headers) {
      return axios.delete(`${URL}/api/v1/folders/${folder}`, {
        headers: headers
      })
    }
  },
  Resource: {
    // create the presigned URL
    createResource (data, headers) {
      return axios.post(
        `${URL}/api/v1/resources/upload`,
        data, {
          headers: headers
        }
      )
    },
    uploadResource (presignedURL, file, config) {
      return axios.put(presignedURL, file, config)
    },
    delete (res, headers) {
      return axios.delete(`${URL}/api/v1/resources/${res}`, {
        headers: headers
      })
    }
  }
}
